import React from 'react';

const MusicaContext = React.createContext();

export default MusicaContext;